import { get, filter, map, pipe, values } from 'lodash/fp';
import { createSelector } from 'reselect';

const enabledFeatureFlagsSelector = createSelector(
  get('featureFlags'),
  pipe(values, filter('enabled'), map('name')),
);

export default enabledFeatureFlagsSelector;
